module.exports = __webpack_public_path__ + "static/media/sense.fa914a6a.png";